import { batch } from 'react-redux'


export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

const showLoadingDispatch = () => {
    return {
        type: SHOW_LOADING, 
        data:true
    };
}

const hideLoadingDispatch = () => {
    return {
        type: HIDE_LOADING,
        data:false 
    };
}

export const showLoading = () => dispatch => {
    process_loading_show(dispatch)
}

export const hideLoading = () => dispatch => {
    process_loading_hide(dispatch)
}

function process_loading_show (dispatch){
    batch(() => {
        dispatch(showLoadingDispatch());
    })
}

function process_loading_hide (dispatch){
    batch(() => {
    dispatch(hideLoadingDispatch());
})
}
